import React from "react";
import PillCerrado from "../../../components/pillEstatus/PillCerrado";

export default function Cerrado() {
  return <PillCerrado />;
}
